import React from "react";

import { CATEGORIES } from "../notificationCategories";

const PATHS = {
  CANCELLED: <><circle cx="12" cy="12" r="8.5" /><path d="M9 9l6 6M15 9l-6 6" /></>,
  REFUND: <><path d="M4 9h11a4.5 4.5 0 010 9H9" /><path d="M7.5 5.5L4 9l3.5 3.5" /></>,
  PAYMENT: <><rect x="3" y="6" width="18" height="12" rx="2.5" /><path d="M3 10h18" /><path d="M7 14.5h3" /></>,
  DISPATCHED: <><path d="M3 7h10v9H3z" /><path d="M13 10h4l3 3v3h-7z" /><circle cx="7" cy="18" r="1.6" /><circle cx="17" cy="18" r="1.6" /></>,
  DELIVERED: <><path d="M20 7.5l-9.5 9.5L5 11.5" /></>,
  ORDER_CONFIRMED: <><circle cx="12" cy="12" r="8.5" /><path d="M8.5 12.2l2.4 2.4 4.6-4.9" /></>,
  REVIEW: <><path d="M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.7l5.4-.8z" /></>,
  PROMO: <><path d="M12 3.8l2 2h3.2v3.2l2 2-2 2v3.2H14l-2 2-2-2H6.8v-3.2l-2-2 2-2V5.8H10z" /><path d="M9.8 14.2l4.4-4.4" /><circle cx="9.9" cy="9.9" r=".9" /><circle cx="14.1" cy="14.1" r=".9" /></>,
  PENDING: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 1.8" /></>,
  ORDER_PLACED: <><path d="M4.5 7.5l7.5-3.5 7.5 3.5v9L12 20l-7.5-3.5z" /><path d="M4.5 7.5L12 11l7.5-3.5M12 11v9" /></>,
  GENERAL: <><path d="M18 8.5a6 6 0 10-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5z" /><path d="M13.7 18.5a2 2 0 01-3.4 0" /></>,
};

const CategoryIcon = ({ categoryKey }) => {
  const category = CATEGORIES[categoryKey] || CATEGORIES.GENERAL;

  return (
    <span className="nt-badge" style={{ background: category.tint }}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke={category.color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {PATHS[category.key] || PATHS.GENERAL}
      </svg>
    </span>
  );
};

export default CategoryIcon;
